
import VueHorizontal from "vue-horizontal";
export default {
  components: { VueHorizontal },
  data() {
    return {
      left: 0,
      originX: 0,
      originLeft: 0,
      options: [
        {
          name: "image",
          label: "Slika",
          type: "image",
        },
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
      ],
    };
  },
  methods: {
    // horizontal
    onScroll({ left }) {
      this.left = left;
    },
    onMouseDown(e) {
      this.originX = e.pageX;
      this.originLeft = this.left;

      window.addEventListener("mouseup", this.onMouseUp, { passive: true });
      window.addEventListener("mousemove", this.onMouseMove, { passive: true });
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp, { passive: true });
      window.removeEventListener("mousemove", this.onMouseMove, {
        passive: true,
      });
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeft - offset;

      this.$refs.horizontal.scrollToLeft(left, "auto");
    },
  },
};
